<template>
  <b-dropdown
    toggle-class="dropdown-field d-flex flex-column align-items-center border-0"
    variant="default"
    class="m-0 severity-dropdown"
    menu-class="menu-shadow text-medium"
    :lazy="true"
  >
    <template v-slot:button-content>
      <span :class="SEVERITY_BADGE_MAP[selected]">{{ selectedLabel }}</span>
    </template>
    <b-dropdown-item v-for="option in options" :key="option.id" @click="$emit('select', option)"
      ><span class="text-prime text-medium-1">{{ option.label }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import * as R from 'ramda'
import { SEVERITY_BADGE_MAP, SEVERITY_MAP } from '@/constants/common'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This renders a dropdown having option to select severity options (low, medium, high)
 * @emits
 * - select
 */
export default {
  name: 'SeverityDropdown',
  components: {
    BDropdown,
    BDropdownItem
  },
  props: ['selected'],
  data() {
    return {
      options: Object.values(SEVERITY_MAP),
      SEVERITY_BADGE_MAP
    }
  },
  computed: {
    selectedLabel() {
      const option = this.options.find(R.propEq('id', this.selected)) || {}
      return option.label
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/badge';
</style>
<style lang="scss">
.severity-dropdown.dropdown {
  position: initial;

  .dropdown-field {
    padding-left: 8px;
    padding-right: 8px;

    &:after {
      display: none;
    }

    &:hover {
      color: inherit;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
      background: #edf8fe;

      button {
        border-color: transparent;
      }
    }

    button:focus {
      box-shadow: none;
      border-color: transparent;
    }
  }

  &.show .dropdown-field {
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
    color: inherit;

    button {
      border-color: transparent;
    }
  }
}
</style>
